import { BaseAuthenticatedComponent } from './../base-authenticated/base-authenticated.component';
import { VerificaMedicoComponent } from './verifica-medico/verifica-medico.component';
import { AssocOperatoriAuth } from '../../@core/models/team_operatori';
import { AutorizzazioneDistretto, Utente } from '../../@core/models/utente';
import { AziendaSanitaria, Distretto } from '@hm_app/@core/models/anagrafica_geo';
import { RuoliUtente, AutorizzazioneOperatore, AssocDistrAuth } from '@hm_app/@core/models/utente';
import { Component, OnInit, Input } from '@angular/core';
import * as _ from 'lodash-es';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangeAuthComponent } from './change-auth/change-auth.component';
import { Router } from '@angular/router';
import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';
import { TeamOperatoreDistretto } from '@hm_app/@core/models/team_operatori';
import { Gravidanza } from '@hm_app/@core/models/gravidanza';
import { NbRoleProvider } from '@nebular/security';
import { NbToastrService } from '@nebular/theme';

interface AssociazDistr {
    distretto: Distretto,
    autorizzazione: AutorizzazioneDistretto
}

@Component({
    selector: 'ngx-autorizzazioni',
    templateUrl: './autorizzazioni.component.html',
    styleUrls: ['./autorizzazioni.component.scss'],
})
export class AutorizzazioniComponent extends BaseAuthenticatedComponent implements OnInit {
    autorizzazione_medici: AutorizzazioneOperatore[];
    autorizzazione_distretti: AutorizzazioneDistretto[];
    aziende_titolare_dati: AziendaSanitaria[];

    private _utente: Utente;
    private _gravidanza: Gravidanza;

    get gravidanza(): Gravidanza {
        return this._gravidanza;
    }

    @Input() set gravidanza(value: Gravidanza) {
        this._gravidanza = value;
        if (value) {
            this.distretto_gravidanza = _.find(this.distretti, { id: value.distretto });
        }
    }

    public get utente(): Utente {
        return this._utente;
    }

    @Input() public set utente(value: Utente) {
        this._utente = value;
        this.getAutorizzazioni(false).then();
    }


    private _distretto_gravidanza: Distretto;
    public get distretto_gravidanza(): Distretto {
        return this._distretto_gravidanza;
    }
    public set distretto_gravidanza(value: Distretto) {
        if (value != this._distretto_gravidanza) {
            this._distretto_gravidanza = value;
            this.associaDistretti(this.autorizzazione_distretti);
        }
    }

    distretti: Distretto[] = [];

    aziende: AziendaSanitaria[] = [];
    aziende_universitarie: AziendaSanitaria[] = [];

    associazione_distretto_gravidanza: AssocDistrAuth;

    associazione_auth_distretti: AssocDistrAuth[];
    current_associazione: AssocDistrAuth;
    current_associazione_operatori: AssocOperatoriAuth[];

    RuoliUtente = RuoliUtente;

    constructor(
        protected hmService: HappyMammaService,
        protected modalService: NgbModal,
        protected router: Router,
        protected toastrService: NbToastrService,
        protected roleProvider: NbRoleProvider
    ) { super(hmService, toastrService, roleProvider); }

    async ngOnInit() {

        this.distretti = await this.hmService.distrettiAllPromise();
        this.aziende = (await this.hmService.aziendeAllPromise()).filter(x => !x.universitaria);
        this.aziende_universitarie = (await this.hmService.aziendeAllPromise()).filter(x => x.universitaria);



        if (this.isUser) {
            const profilo_utente = await this.hmService.getCurrentUserProfile();
            this.utente = profilo_utente.utente;
            this.gravidanza = profilo_utente.gravidanza_in_corso;
        }
        else {
            if (this.utente) {
                const profilo_utente = await this.hmService.getUserProfile(this.utente.id);
                this.utente = profilo_utente.utente;
                this.gravidanza = profilo_utente.gravidanza_in_corso;
            }
        }

        let azienda_titolare = this.aziende.find(a => a.id == this.gravidanza?.azienda_sanitaria);
        this.aziende_titolare_dati = [];
        this.aziende_titolare_dati.push(azienda_titolare);
        this.autorizzazione_distretti.filter(d => d.status == 'authorized').forEach(dis => {
            let distretto = this.distretti.find(d => d.id == dis.distretto);
            if (distretto.azienda_sanitaria != this.gravidanza.azienda_sanitaria) {
                let azienda_to_add = this.aziende.find(a => a.id == distretto.azienda_sanitaria);
                if (!azienda_to_add)
                    azienda_to_add = this.aziende_universitarie.find(a => a.id == distretto.azienda_sanitaria);
                if (azienda_to_add && !this.aziende_titolare_dati.includes(azienda_to_add))
                    this.aziende_titolare_dati.push(azienda_to_add);
            }


        })
    }

    async selectAuthDist(a: AssocDistrAuth) {
        this.current_associazione = a;

        if (!a) {
            this.current_associazione_operatori = null;
            return;
        }


        let operatoriDistretto = await this.hmService.getOperatoriDistretto(a.distretto.id).toPromise();
        let ops: TeamOperatoreDistretto[] = operatoriDistretto.map<TeamOperatoreDistretto>(o => {
            let ret = new TeamOperatoreDistretto();
            ret.cod_fiscale = o.Operatore.username;
            ret.role = RuoliUtente[o.Operatore.role];
            ret.nome = o.user_nominativo;
            return ret;
        })

        const associazioni: AssocOperatoriAuth[] = [];
        const operatori = _.sortBy(ops, ['id']);

        operatori.forEach(team_operatore => {
            const autorizzazione = _.find(this.autorizzazione_medici, { 'cf_medico': team_operatore.cod_fiscale });
            associazioni.push({ 'team_operatore': team_operatore, 'autorizzazione': autorizzazione });
        });

        this.current_associazione_operatori = associazioni;
    }

    can_manage_district(distretto: Distretto) {
        return this.isAdmin || _.find(this.user.capability_rules.nascita.distretti, { id: distretto.id }) != null;
    }

    associaDistretti(autorizzazione_distretti: AutorizzazioneDistretto[]) {
        if (!this.autorizzazione_distretti) {
            return;
        }
        let associazioni: AssociazDistr[] = [];

        this.associazione_distretto_gravidanza = null;
        this.distretti.forEach(d => {

            let distretto_gestito = this.isOperator && this.can_manage_district(d);
            const autorizzazione = _.find(this.autorizzazione_distretti, { 'distretto': d.id });

            if (this.isUser || this.isAdmin || autorizzazione || distretto_gestito /*TODO: or is superadmin */ /* TODO: or in team distretto */) {
                if (this.distretto_gravidanza && this.distretto_gravidanza.id == d.id) {
                    this.associazione_distretto_gravidanza = { distretto: d, autorizzazione: autorizzazione };
                } else {
                    associazioni.push({ distretto: d, autorizzazione: autorizzazione });
                }
            }
        });

        associazioni = _.sortBy(associazioni, (a: AssociazDistr) => {
            return [
                !a.autorizzazione || a.autorizzazione.status != 'authorized',
                !a.autorizzazione || a.autorizzazione.status != 'denied',
                !a.autorizzazione || a.autorizzazione.status != 'requested',
                a.distretto.area_vasta,
                a.distretto.nome,
            ];
        });
        this.associazione_auth_distretti = associazioni;
    }

    async getAutorizzazioni(do_refresh: boolean = true) {
        try {
            if (!this.isUser && !this.utente) {
                console.error("getAutorizzazioni, nessun utente");
                return;
            }

            if (do_refresh || !this.utente) {
                let profilo_utente = null;
                if (this.isUser) {
                    profilo_utente = await this.hmService.getCurrentUserProfile(true);
                } else {
                    profilo_utente = await this.hmService.getUserProfile(this.utente.id);
                }

                this.utente = profilo_utente.utente;
                this.gravidanza = profilo_utente.gravidanza_in_corso;

            }

            this.autorizzazione_medici = this.utente.autorizzazione_medici;
            this.autorizzazione_distretti = this.utente.autorizzazione_distretti;



            this.associaDistretti(this.autorizzazione_distretti);
            this.selectAuthDist(this.current_associazione);
        } catch (e) {
            const exception = e;
            console.error(e);
            if (exception.status == 406 || exception.status == 401) {
                this.router.navigate(['/auth/login']);
                return;
            }
            throw e;
        }
    }

    get autorizzazioni_ostetriche() {
        return _.filter(this.autorizzazione_medici, { role: RuoliUtente.ostetrica });
    }

    get autorizzazioni_ginecologi() {
        return _.filter(this.autorizzazione_medici, { role: RuoliUtente.medico_ginecologo });
    }

    get autorizzazione_medici_generici() {
        return _.filter(this.autorizzazione_medici, { role: RuoliUtente.medico_generico });
    }

    changeAuthorizationTeamOperatore(associazione: AssocOperatoriAuth) {
        if (this.isUser) {
            this.changeMyAuthorizationTeamOperatore(associazione);
        } else {
            this.requireAuthorizationTeamOperatore(associazione);
        }
    }

    requireAuthorizationTeamOperatore(associazione: AssocOperatoriAuth) {
        return;
        // const cod_fiscale = associazione.team_operatore.cod_fiscale;
        // const role = associazione.team_operatore.role;
        // const denominazione = associazione.team_operatore.cognome + " " + associazione.team_operatore.nome;
        // const status = associazione.autorizzazione ? associazione.autorizzazione.status : 'undefined';
        // if (status == 'authorized' ) {
        //   return;
        // }
        // const modal = this.modalService.open(ChangeAuthComponent, { container: 'nb-layout' });
        // modal.componentInstance.authChanged.subscribe(authChanged => {
        //   if (authChanged) {
        //     this.getAutorizzazioni().then();
        //   }
        // });
        // modal.componentInstance.show_nega = false;
        // modal.componentInstance.show_annulla = true;
        // modal.componentInstance.show_autorizza = false;
        // modal.componentInstance.show_richiedi = true;
        // modal.componentInstance.title = "confermi di voler richiedere l'autorizzazione per l'operatore " + cod_fiscale + " - " + denominazione
        // ' ad accedere alle informazioni relative al libretto gravidanza?';
    }

    changeMyAuthorizationTeamOperatore(associazione: AssocOperatoriAuth) {

        const cod_fiscale = associazione.team_operatore.cod_fiscale;
        const role = associazione.team_operatore.role;
        const denominazione = associazione.team_operatore.cognome + " " + associazione.team_operatore.nome;

        const status = associazione.autorizzazione ? associazione.autorizzazione.status : 'undefined';

        const modal = this.modalService.open(ChangeAuthComponent, { container: 'nb-layout' });
        modal.componentInstance.authChanged.subscribe(authChanged => {
            if (authChanged) {
                this.getAutorizzazioni().then();
            }
        });
        switch (status) {
            case 'denied':
                modal.componentInstance.show_nega = false;
                modal.componentInstance.show_annulla = true;
                modal.componentInstance.show_autorizza = true;
                modal.componentInstance.title = "confermi di voler autorizzare l'operatore " + cod_fiscale + " - " + denominazione;
                ' ad accedere alle informazioni relative al tuo libretto gravidanza?';
                break;
            case 'authorized':
                modal.componentInstance.show_nega = true;
                modal.componentInstance.show_annulla = true;
                modal.componentInstance.show_autorizza = false;
                modal.componentInstance.title = "confermi di voler autorizzare l'operatore " + cod_fiscale + " - " + denominazione +
                    ' ad accedere alle informazioni relative al tuo libretto gravidanza?';
                break;
            case 'requested':
            default:
                modal.componentInstance.show_nega = true;
                modal.componentInstance.show_annulla = true;
                modal.componentInstance.show_autorizza = true;
                modal.componentInstance.title = "Imposta l'autorizzazione dell'operatore " + cod_fiscale + " - " + denominazione +
                    ' per l\'accesso alle informazioni relative al tuo libretto gravidanza';
                break;
        }

        modal.componentInstance.user = this.utente;
        modal.componentInstance.cf_medico = cod_fiscale;
        modal.componentInstance.ruolo = role;
        modal.componentInstance.denominazione = denominazione;
    }

    changeDistrictAuthStatus(associazione: AssocDistrAuth) {
        if (this.isUser) {
            this.changeMyDistrictAuthStatus(associazione);
        } else {
            this.requestChangeDistrictAuthStatus(associazione);
        }
    }

    requestChangeDistrictAuthStatus(associazione: AssocDistrAuth) {
        if (!this.can_manage_district(associazione.distretto)) {
            return;
        }

        const autorizzazione = associazione.autorizzazione;

        const distretto = associazione.distretto;

        const status = autorizzazione ? autorizzazione.status : 'undefined';
        if (status == 'authorized') {
            return;
        }

        const modal = this.modalService.open(ChangeAuthComponent, { container: 'nb-layout' });
        modal.componentInstance.authChanged.subscribe(authChanged => {
            if (authChanged) {
                this.getAutorizzazioni().then();
            }
            modal.componentInstance.authChanged.unsubscribe();
        });

        modal.componentInstance.user = this.utente;
        modal.componentInstance.show_nega = false;
        modal.componentInstance.show_annulla = true;
        modal.componentInstance.show_richiedi = true;
        modal.componentInstance.show_autorizza = false;
        modal.componentInstance.show_forza = true;
        modal.componentInstance.title = "Confermi di voler richiedere l'autorizzazione per il distretto " + distretto.nome +
            " ad accedere alle informazioni relative al libretto gravidanza?";

        modal.componentInstance.distretto = distretto.id;
    }


    changeMyDistrictAuthStatus(associazione: AssocDistrAuth) {

        const autorizzazione = associazione["autorizzazione"];

        const distretto = associazione["distretto"];

        const status = autorizzazione ? autorizzazione.status : 'undefined';

        const modal = this.modalService.open(ChangeAuthComponent, { container: 'nb-layout' });
        modal.componentInstance.authChanged.subscribe(authChanged => {
            if (authChanged) {
                this.getAutorizzazioni().then();
            }
        });
        switch (status) {
            case 'denied':
                modal.componentInstance.show_nega = false;
                modal.componentInstance.show_annulla = true;
                modal.componentInstance.show_autorizza = true;
                modal.componentInstance.title = 'Confermi di voler autorizzare il distretto ' + distretto.nome +
                    ' ad accedere alle informazioni relative al tuo libretto gravidanza?';
                break;
            case 'authorized':
                modal.componentInstance.show_nega = true;
                modal.componentInstance.show_annulla = true;
                modal.componentInstance.show_autorizza = false;
                modal.componentInstance.title = 'Confermi di voler negare l\'autorizzazione al distretto ' + distretto.nome +
                    ' ad accedere alle informazioni relative al tuo libretto gravidanza?';
                break;
            case 'requested':
            default:
                modal.componentInstance.show_nega = true;
                modal.componentInstance.show_annulla = true;
                modal.componentInstance.show_autorizza = true;
                modal.componentInstance.title = "Imposta l'autorizzazione del distretto " + distretto.nome +
                    ' per permettere di accedere alle informazioni relative al tuo libretto gravidanza?';
                break;
        }

        modal.componentInstance.distretto = distretto.id;

    }

    changeOperatorAuthStatus(autorizzazione: AutorizzazioneOperatore) {
        if (this.isUser) {
            this.changeMyOperatorAuthStatus(autorizzazione);
        } else {
            this.requestChangeOperatorAuthStatus(autorizzazione);
        }
    }

    requestChangeOperatorAuthStatus(autorizzazione: AutorizzazioneOperatore) {

        const status = autorizzazione ? autorizzazione.status : 'undefined';
        if (status == 'authorized' || status == 'requested') {
            return;
        }

        const modal = this.modalService.open(ChangeAuthComponent, { container: 'nb-layout' });
        modal.componentInstance.authChanged.subscribe(authChanged => {
            if (authChanged) {
                this.getAutorizzazioni().then();
                this.current_associazione = this.current_associazione;
            }
        });

        modal.componentInstance.show_nega = false;
        modal.componentInstance.show_annulla = true;
        modal.componentInstance.show_richiedi = true;
        modal.componentInstance.show_autorizza = false;
        modal.componentInstance.title = 'Confermi di voler richiedere l\'autorizzazione al professionista ' + autorizzazione.denominazione +
            ' ad accedere alle informazioni relative al tuo libretto gravidanza';

        modal.componentInstance.ruolo = autorizzazione.role;
        modal.componentInstance.denominazione = autorizzazione.denominazione;
        modal.componentInstance.cf_medico = autorizzazione.cf_medico;
        modal.componentInstance.user = this.utente;
    }


    changeMyOperatorAuthStatus(autorizzazione: AutorizzazioneOperatore) {

        const status = autorizzazione ? autorizzazione.status : 'undefined';

        const modal = this.modalService.open(ChangeAuthComponent, { container: 'nb-layout' });
        modal.componentInstance.authChanged.subscribe(authChanged => {
            if (authChanged) {
                this.getAutorizzazioni().then();
                this.current_associazione = this.current_associazione;

            }
        });
        switch (status) {
            case 'denied':
                modal.componentInstance.show_nega = false;
                modal.componentInstance.show_annulla = true;
                modal.componentInstance.show_autorizza = true;
                modal.componentInstance.title = 'Confermi di voler autorizzare il professionista ' + autorizzazione.denominazione +
                    ' ad accedere alle informazioni relative al tuo libretto gravidanza?';
                break;
            case 'authorized':
                modal.componentInstance.show_nega = true;
                modal.componentInstance.show_annulla = true;
                modal.componentInstance.show_autorizza = false;
                modal.componentInstance.title = 'Confermi di voler negare l\'autorizzazione al professionista ' + autorizzazione.denominazione +
                    ' ad accedere alle informazioni relative al tuo libretto gravidanza?';
                break;
            case 'requested':
            default:
                modal.componentInstance.show_nega = true;
                modal.componentInstance.show_annulla = true;
                modal.componentInstance.show_autorizza = true;
                modal.componentInstance.title = "Imposta l'autorizzazione al professionista " + autorizzazione.denominazione +
                    ' ad accedere alle informazioni relative al tuo libretto gravidanza?';
                break;
        }

        modal.componentInstance.ruolo = autorizzazione.role;
        modal.componentInstance.denominazione = autorizzazione.denominazione;
        modal.componentInstance.cf_medico = autorizzazione.cf_medico;

    }

    async verifica_medico(event: any) {

        let cod_fiscale = this.isUser ? null : this._utente?.cod_fiscale;

        try {
            const desc_medico_famiglia = await this.hmService.verifica_medico(cod_fiscale).toPromise();
            // console.log("verifica_medico", desc_medico_famiglia);
            if (!desc_medico_famiglia || !desc_medico_famiglia.cf_medico) {
                // console.log("nessun medico");
                // TODO: GESTIRE
                this.showToast('danger', 'nessun medico associato ', null);

                return;
            }

            const auth_medico = _.find(this.autorizzazione_medici, { cf_medico: desc_medico_famiglia.cf_medico });

            const activeModal = this.modalService.open(VerificaMedicoComponent, {
                size: 'sm',
                container: 'nb-layout',
            });
            activeModal.componentInstance.autorizzazione = null;
            activeModal.componentInstance.desc_medico_famiglia = desc_medico_famiglia;
            activeModal.componentInstance.can_request = this.isUser;

            if (this.isUser) {
                activeModal.componentInstance.onAuth.subscribe(dmf => {
                    this.hmService.changeDoctorAuthorization(dmf.cf_medico, dmf.denominazione_medico, 'medico_generico', 'authorized').toPromise().then(x => this.getAutorizzazioni());
                    activeModal.componentInstance.onAuth.unsubscribe();

                });
            }
        } catch (errorResponse) {
            this.showToast('danger', 'impossibile ottenere il medico ', null);
        }

    }

    getAssDistrettiByAzienda(id_azienda: number): AssocDistrAuth[] {
        return (this.associazione_auth_distretti || []).filter(item => item.distretto.azienda_sanitaria == id_azienda);
    }

}
